import { useState, useEffect } from 'react'

function parseQuery(query) {
  
  const minWidthMatch = query.match(/\(min-width:\s*(\d+)px\)/)
  const maxWidthMatch = query.match(/\(max-width:\s*(\d+)px\)/)
  const minHeightMatch = query.match(/\(min-height:\s*(\d+)px\)/)
  const maxHeightMatch = query.match(/\(max-height:\s*(\d+)px\)/)


  return {
    minWidth: minWidthMatch ? parseInt(minWidthMatch[1], 10) : null,
    maxWidth: maxWidthMatch ? parseInt(maxWidthMatch[1], 10) : null,
    minHeight: minHeightMatch ? parseInt(minHeightMatch[1], 10) : null,
    maxHeight: maxHeightMatch ? parseInt(maxHeightMatch[1], 10) : null,
  }
}

function useMediaQuery(query) {
  const [innerWidth, setInnerWidth] = useState(0)
  const [innerHeight, setInnerHeight] = useState(0)


  const evaluateQuery = () => {
    const { minWidth, maxWidth, minHeight, maxHeight } = parseQuery(query)

    return (
      (minWidth === null || innerWidth >= minWidth) &&
      (maxWidth === null || innerWidth <= maxWidth) &&
      (minHeight === null || innerHeight >= minHeight) &&
      (maxHeight === null || innerHeight <= maxHeight)
    )
  }

  
  const [matches, setMatches] = useState(evaluateQuery())

  useEffect(() => {
    setMatches(evaluateQuery())

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, innerWidth, innerHeight])

  useEffect(() => {
    // Request viewport info
    window.parent.postMessage({
      type: 'REQUEST_VIEWPORT_INFO'
    }, "*")

    // Listen for responses
    window.addEventListener('message', function (event) {
      switch (event.data.type) {
        case 'VIEWPORT_INFO_RESPONSE':
          setInnerWidth(event.data.innerWidth)
          setInnerHeight(event.data.innerHeight)
          break
      }
    })
  }, [])

  return matches
}

export default useMediaQuery
